/**
 * Web mock for react-native-image-picker.
 * This package's real source is TypeScript that webpack's default loader
 * config can't parse (it's meant for Metro, not webpack). ScanBusinessCardScreen
 * already guards its actual camera-scan flow behind Platform.OS === 'web'
 * (shows "not available on web" and returns before ever calling this), so
 * these never really execute on web - they only need to exist so webpack
 * can resolve the import without trying to parse the real package.
 */

function launchCamera(options, callback) {
  const result = { didCancel: true };
  if (typeof callback === 'function') {
    callback(result);
    return;
  }
  return Promise.resolve(result);
}

function launchImageLibrary(options, callback) {
  const result = { didCancel: true };
  if (typeof callback === 'function') {
    callback(result);
    return;
  }
  return Promise.resolve(result);
}

module.exports = { launchCamera, launchImageLibrary };
